import { MerchantRecommendedExchangeSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/merchant-recommended-exchange";
import * as z from "zod";

export const updateMerchantRecommendedExchanges = {
  name: "updateMerchantRecommendedExchanges" as const,
  input: z.object({
    enableMerchantRecommendedExchanges: z.boolean(),
    merchantRecommendedExchanges: z.array(MerchantRecommendedExchangeSchema),
  }),
  output: z.object({}),
};
